export default __webpack_public_path__ + "static/media/Нэгдсэн сургалт БЕГ багш, удирдах ажилтны ёс зүйн манлайлал.4150710e.pdf";